<template>
    <div class="payment-method">
        <a
            href="#!"
            class="payment-btn"
            :class="{
                        selected: selectedPaymentMethod && selectedPaymentMethod.id === paymentMethod.id,
                        recommended: paymentMethod.group === 'recommended',
                    }"
            @click="setPaymentMethod(paymentMethod)"
        >
            <h5 class="action">
                {{$t('subscription.buttons.pay_using')}}
            </h5>
            <div
                class="payment-method-img"
                :style="{backgroundImage: `url('${paymentMethod.image_url}')`}"
            >
            </div>
            <h5 class="name">{{paymentMethod.name}}</h5>
        </a>
    </div>
</template>
<script>
export default {
    name: 'PaymentMethodCardOption',
    props: {
        paymentMethod: {},
        selectedPaymentMethod: {}
    },
    methods: {
        setPaymentMethod(paymentMethod){
            this.$emit('click', paymentMethod);
        },
    },
}
</script>
<style scoped lang="scss">
@import './../styles/variables';
@import './../styles/classes';

.payment-method{
    text-align: center;
    width: auto;
    
    .payment-btn{
        display: block;
        min-width: 120px;
        margin: .5em 0;
        padding: .5em;
        border-radius: 5px;
        @extend %fresh-btn;
    
        .action{
            color: $pallete_clear_text_color;
            margin: 0 0 .5em 0;
        }
    
        .payment-method-img{
            display: block;
            margin-left: auto;
            margin-right: auto;
            transition: filter .5s;
            width: 100px;
            height: 100px;
            box-shadow: 1px 1px 3px rgba(0,0,0,.25);
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
            border-radius: 50%;
            background-color: $pallete_clear_color;
            filter: grayscale(100%);
        }

        .name{
            margin: .5em 0 0 0;
        }
        
        &.selected{
            background-color: rgba($pallete_main_color, 0.85);
            
            .payment-method-img{
                filter: grayscale(0%);
            }
        }
    
        &.recommended{
            .payment-method-img{
                width: 150px;
                height: 150px;
            }
            
            .action{
                font-size: 1.3em;
            }
        
            .name{
                font-size: 1.3em;
            }

            .payment-btn{
                min-width: 120px;
                margin: .5em 0;
                padding: .5em;
                border-radius: 50px;
            }
        }
    }
}
</style>